<app-breadcrumbs [title]="'MENU.DATA_SYNC.MAIN'" [first]="'MENU.DATA_SYNC.MAIN'"></app-breadcrumbs>

<div class="btn-container">
    <dx-button *ngIf="authorities.create" class="ml-2 navbar-button" [height]="32" stylingMode="contained" icon="plus" [text]="'SHARED.CREATE' | translate" type="success" [routerLink]="'./new'"></dx-button>

</div>

<div class="row">
    <dx-data-grid #table 
                    class="col-12"
                    [dataSource]="dataSource" 
                    [rowAlternationEnabled]="true" 
                    [columnAutoWidth]="true"
                    [showBorders]="true" 
                    [showRowLines]="false" 
                    [showColumnLines]="false" 
                    [hoverStateEnabled]="true"
                    [allowColumnResizing]="true" 
                    [allowColumnReordering]="true"
                    columnResizingMode="nextColumn"
                    [masterDetail]="{ enabled: true, template: 'configurationItems' }"
                    >
    
        <dxo-remote-operations [filtering]="true" [paging]="true" [sorting]="true"></dxo-remote-operations>
        <dxo-filter-row [visible]="false"></dxo-filter-row>
        <dxo-paging [pageSize]="15"></dxo-paging>
        <dxo-pager [showInfo]="true"></dxo-pager>
        <!-- <dxo-state-storing [enabled]="true" [type]="'custom'" [customLoad]="loadGridState" [customSave]="saveGridState"></dxo-state-storing> -->

        <dxi-column dataField="companyId" dataType="string" [allowFiltering]="true" [allowSorting]="false" [caption]="'COMPANIES.COMPANY'  | translate"></dxi-column>
        <dxi-column dataField="recordsPerDataPatch" dataType="string" [allowFiltering]="true" [allowSorting]="false" [caption]="'DATA_SYNC.CONFIGURATION.RECORDS_PER_DATA_PATCH'  | translate"></dxi-column>
        <dxi-column dataField="dataPatchesPerRequest" dataType="string" [allowFiltering]="true" [allowSorting]="false" [caption]="'DATA_SYNC.CONFIGURATION.DATA_PATCHES_PER_REQUEST'  | translate"></dxi-column>

        <!-- <dxi-column dataField="version" dataType="string" [allowFiltering]="false" [allowSorting]="false" ></dxi-column> -->
        <dxi-column dataField="active" dataType="boolean" [allowFiltering]="false" [allowSorting]="false" ></dxi-column>

        <dxi-column cellTemplate="actionsTemplate" *ngIf="editable || deletable"[allowFiltering]="false" [allowSorting]="false" [fixed]="true" fixedPosition="right" [width]="70" [caption]="''" [cssClass]="'actions'"></dxi-column>
    
        <div *dxTemplate="let template of 'actionsTemplate'">
            <span *ngIf="editable" class="table-icon ti-eye" [matTooltip]="'SHARED.VIEW' | translate" matTooltipPosition="above" matTooltipHideDelay="200" [routerLink]="['./', template.data.id]"></span>
            <span *ngIf="deletable" class="table-icon dx-icon-trash" [matTooltip]="'SHARED.DELETE' | translate" matTooltipPosition="above" matTooltipHideDelay="200" (click)="delete(template.data.id)"></span>
        </div>


        <div *dxTemplate="let template of 'configurationItems'">
            <div class="container">
                <span class="details-title">{{ 'DATA_SYNC.CONFIGURATION.CONFIGURATION_ITEMS' | translate }}</span>
                <hr class="wsh-hr hr-margin">
                <div class="row">
                    <div class="col-md-12">
                        <dx-data-grid class="smaller-header" 
                        [dataSource]="template.data.configurationItems" 
                        [showColumnLines]="false" [showRowLines]="true" 
                        [showBorders]="true" 
                        [rowAlternationEnabled]="true"
                        [masterDetail]="{ enabled: true, template: 'syncItems' }">

                        <dxi-column cellTemplate="rowTemplate" dataField="id" dataType="string" [allowFiltering]="false" [allowSorting]="false"
                            [caption]="'SHARED.ROW_NUMBER' | translate"></dxi-column>

                            <dxi-column dataField="type" dataType="string" [allowFiltering]="false" [allowSorting]="false" [caption]="'SHARED.TYPE' | translate"></dxi-column>
                            <!-- <dxi-column dataField="id" dataType="string" [allowFiltering]="false" [allowSorting]="false" [caption]="'SHARED.ID' | translate"></dxi-column>
                            <dxi-column dataField="version" dataType="string" [allowFiltering]="false" [allowSorting]="false" ></dxi-column> -->

                            <div *dxTemplate="let row of 'rowTemplate'">
                                <text class="text-center" >{{ getRowNumber(row.data, template.data.configurationItems) }}</text>
                            </div>
                    
                            <div *dxTemplate="let template of 'syncItems'">
                                <div class="container">
                                    <span class="details-title">{{ 'DATA_SYNC.CONFIGURATION.SYNC_ITEMS' | translate }}</span>
                                    <dx-data-grid class="smaller-header" 
                                    [dataSource]="template.data.syncItems" 
                                    [showColumnLines]="false" [showRowLines]="true" 
                                    [showBorders]="true" 
                                    [rowAlternationEnabled]="true" 
                                    [masterDetail]="{ enabled: true, template: 'fieldMappings' }">
                                    
                                    <dxi-column cellTemplate="rowTemplate" dataField="id" dataType="string" [allowFiltering]="false" [allowSorting]="false"
                                    [caption]="'SHARED.ROW_NUMBER' | translate"></dxi-column>
                                    <dxi-column dataField="clientSpecific" dataType="boolean" [allowFiltering]="false" [allowSorting]="false" ></dxi-column>
                                    <!-- <dxi-column dataField="id" dataType="string" [allowFiltering]="false" [allowSorting]="false" ></dxi-column>
                                    <dxi-column dataField="version" dataType="string" [allowFiltering]="false" [allowSorting]="false" ></dxi-column> -->

                                    <dxi-column cellTemplate="actionsTemplate" *ngIf="editable" [allowFiltering]="false" [allowSorting]="false" [fixed]="true" fixedPosition="right" [width]="70" [caption]="''" [cssClass]="'actions'"></dxi-column>
    
                                    <div *dxTemplate="let row of 'rowTemplate'">
                                        <text class="text-center" >{{ getRowNumber(row.data, template.data.syncItems) }}</text>
                                    </div>
                                    <div *dxTemplate="let template of 'actionsTemplate'">
                                        <span *ngIf="editable" class="table-icon ti-eye" [matTooltip]="'SHARED.VIEW' | translate" matTooltipPosition="above" matTooltipHideDelay="200" (click)="viewObjects(template.data)" ></span>
                                    </div>
                                    <div *dxTemplate="let template of 'fieldMappings'">
                                        <div class="container">
                                            <span class="details-title">{{ 'DATA_SYNC.CONFIGURATION.FIELD_MAPPINGS' | translate }}</span>
                                            <dx-data-grid class="smaller-header" 
                                            [dataSource]="template.data.fieldMappings" 
                                            [showColumnLines]="false" [showRowLines]="true" 
                                            [showBorders]="true" 
                                            [rowAlternationEnabled]="true" 
                                            >
                                            <dxi-column dataField="serverFieldName" dataType="string" [allowFiltering]="false" [allowSorting]="false" ></dxi-column>
                                            <dxi-column dataField="clientFieldName" dataType="string" [allowFiltering]="false" [allowSorting]="false" ></dxi-column>
                                            <dxi-column dataField="ignore" dataType="string" [allowFiltering]="false" [allowSorting]="false" ></dxi-column>
                                            <dxi-column dataField="key" dataType="boolean" [allowFiltering]="false" [allowSorting]="false" ></dxi-column>
                                            <!-- <dxi-column dataField="id" dataType="string" [allowFiltering]="false" [allowSorting]="false" ></dxi-column> -->
                                            <!-- <dxi-column dataField="version" dataType="string" [allowFiltering]="false" [allowSorting]="false" ></dxi-column> -->
                                            </dx-data-grid>
                                        </div>
                                    </div>
                                </dx-data-grid>
                                </div>
                            </div>
                        </dx-data-grid>
                    </div>
                </div>
            </div>
        </div>
    </dx-data-grid>
</div>


<dx-popup width="1020px" maxWidth="80%" height="600px" maxHeight="80%" [(visible)]="isObjectsModalVisible"
    [title]="'DATA_SYNC.CONFIGURATION.VIEW_ITEM' | translate">
    <dx-scroll-view height="83.5%">
        <div class="container mt-5">
            <span class="details-title">{{ 'DATA_SYNC.CONFIGURATION.FIELD_MAPPINGS' | translate }}</span>
            <dx-data-grid class="smaller-header" [dataSource]="syncItemModel?.fieldMappings" [showColumnLines]="false"
                [showRowLines]="true" [showBorders]="true" [rowAlternationEnabled]="true">
                <!-- <dxo-editing mode="row" [allowUpdating]="true" [allowDeleting]="true" [allowAdding]="true">
                </dxo-editing> -->
                <dxi-column dataField="serverFieldName" dataType="string" [allowFiltering]="false"
                    [allowSorting]="false"></dxi-column>
                <dxi-column dataField="clientFieldName" dataType="string" [allowFiltering]="false"
                    [allowSorting]="false"></dxi-column>
                <dxi-column dataField="ignore" dataType="string" [allowFiltering]="false" [allowSorting]="false">          
                </dxi-column>
                <dxi-column dataField="key" dataType="boolean" [allowFiltering]="false" [allowSorting]="false">
                </dxi-column>
            </dx-data-grid>
        </div>

        <div class="container mt-5">
            <span class="details-title">{{ 'DATA_SYNC.CONFIGURATION.OBJECTS' | translate }}</span>
            <dx-data-grid class="smaller-header" 
            [dataSource]="syncItemModel?.objects" 
            [showColumnLines]="false"
            [showRowLines]="true" 
            [showBorders]="true" 
            [rowAlternationEnabled]="true"
            [masterDetail]="{ enabled: true, template: 'selectConditions' }">
                <!-- <dxo-editing mode="row" [allowUpdating]="false" [allowDeleting]="false" [allowAdding]="false"></dxo-editing> -->
                <dxi-column cellTemplate="rowTemplate" dataType="string" [allowFiltering]="false" [allowSorting]="false"
                [caption]="'SHARED.ROW_NUMBER' | translate"></dxi-column>

                <dxi-column dataField="type" dataType="string" [allowFiltering]="false" [allowSorting]="false">
                </dxi-column>
                <dxi-column dataField="name" dataType="string" [allowFiltering]="false" [allowSorting]="false">
                </dxi-column>
                <!-- <dxi-column *ngIf="syncItemModel.id != null" dataField="id" dataType="string" [allowFiltering]="false" [allowSorting]="false">
                </dxi-column>
                <dxi-column *ngIf="syncItemModel.id != null" dataField="version" dataType="string" [allowFiltering]="false" [allowSorting]="false">
                </dxi-column> -->

                <div *dxTemplate="let row of 'rowTemplate'">
                    <text class="text-center" >{{ getRowNumber(row.data, syncItemModel?.objects) }}</text>
                </div>

                <div *dxTemplate="let template of 'selectConditions'">
                    <div class="container">
                        <span class="details-title">{{ 'DATA_SYNC.CONFIGURATION.SELECTED_CONDITIONS' | translate }}</span>
                        <dx-data-grid class="smaller-header" 
                        [dataSource]="template.data.selectConditions" 
                        [showColumnLines]="false" [showRowLines]="true" 
                        [showBorders]="true" 
                        [rowAlternationEnabled]="true" 
                        >
                        <dxi-column dataField="condition" dataType="string" [allowFiltering]="false" [allowSorting]="false" ></dxi-column>
                        <dxi-column dataField="value" dataType="string" [allowFiltering]="false" [allowSorting]="false" ></dxi-column>
                        <!-- <dxi-column dataField="id" dataType="string" [allowFiltering]="false" [allowSorting]="false" ></dxi-column> -->
                        <!-- <dxi-column dataField="version" dataType="string" [allowFiltering]="false" [allowSorting]="false" ></dxi-column> -->
                        </dx-data-grid>
                    </div>
                </div>

            </dx-data-grid>
        </div>

        <div *ngIf="syncItemModel?.associatedItems?.length > 0" class="container mt-5">
            <span class="details-title">{{ 'DATA_SYNC.CONFIGURATION.ASSOCIATED_ITEMS' | translate }}</span>
                <dx-data-grid class="smaller-header" [dataSource]="syncItemModel?.associatedItems"
                    [showColumnLines]="false" [showRowLines]="true" [showBorders]="true" [rowAlternationEnabled]="true"
                    >
                    <dxi-column cellTemplate="rowTemplate" dataType="string" [allowFiltering]="false" [allowSorting]="false"
                    [caption]="'SHARED.ROW_NUMBER' | translate"></dxi-column>    

                    <dxi-column dataField="clientSpecific" dataType="boolean" [allowFiltering]="false"
                        [allowSorting]="false"></dxi-column>
                    <!-- <dxi-column *ngIf="syncItemModel?.id != null && syncItemModel?.id != ''" dataField="id" dataType="string" [allowFiltering]="false" [allowSorting]="false">
                    </dxi-column>
                    <dxi-column *ngIf="syncItemModel?.id != null && syncItemModel?.id != ''" dataField="version" dataType="string" [allowFiltering]="false" [allowSorting]="false">
                    </dxi-column> -->
                    <dxi-column cellTemplate="actionsTemplate" [allowFiltering]="false" [allowSorting]="false"
                        [fixed]="true" fixedPosition="right" [width]="70" [caption]="''" [cssClass]="'actions'">
                    </dxi-column>

                    <div *dxTemplate="let t of 'actionsTemplate'">
                        <span  class="table-icon ti-eye" [title]="'SHARED.VIEW' | translate"
                            (click)="viewObjects(t.data)"></span>
                    </div>

                    <div *dxTemplate="let row of 'rowTemplate'">
                        <text class="text-center" >{{ getRowNumber(row.data, syncItemModel?.associatedItems) }}</text>
                    </div>
                </dx-data-grid>
        </div>
    </dx-scroll-view>
</dx-popup>